import React from 'react';
import { FormGroup } from 'react-bootstrap';

export const Input = ({ type, name, placeholder, options }) => {

	const getInput = () => {
		if (type === 'textarea') {
			return <textarea name={name} placeholder={placeholder} required />;
		}
		if (type === 'select') {
			return (
				<select name={name}>
					{options.map(option =>
						<option key={option.text} value={option.text}>{option.text}</option>
					)}
				</select>
			);
		}
		return <input type={type} name={name} placeholder={placeholder} required />;
	};

	return (
		<FormGroup>
			{getInput()}
		</FormGroup>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/Contact/Input.js